module.exports = __webpack_public_path__ + "img/bsn-img.f24bd71b.png";